import { Observable, Subject } from 'rxjs';

/**
 * Reference to a drawer opened via the DrawerService.
 * Can be used to close or receive data from the drawer.
 */
export class DrawerRef<T = any, R = any> {
    private readonly _afterClosed = new Subject<R | undefined>();
    private _result: R | undefined;

    constructor() { }

    /**
     * Close the drawer.
     * @param result Optional result to return to afterClosed subscribers
     */
    close(result?: R): void {
        this._result = result;
        this._afterClosed.next(result);
        this._afterClosed.complete();
    }

    /**
     * Gets an observable that is notified when the drawer is finished closing.
     */
    afterClosed(): Observable<R | undefined> {
        return this._afterClosed.asObservable();
    }

    /**
     * Gets the result passed to close()
     */
    get result(): R | undefined {
        return this._result;
    }
}
